const benefitsData = [
    {
      title: "INOVATIVNO UČENJE",
      subtitle: "Osmišljeno za decu koja mogu više",
      text: "U Savremenoj ne verujemo u pasivno učenje, već da se do znanja dolazi kroz istraživanje, zabavu, igru, drugačiji pristup i osmeh. STEAM projekti, praktičan rad, Cambridge standard i multidisciplinarni časovi znanje pretvaraju u iskustvo. A iskustvo ostaje zauvek.",
    },
    {
      title: "NAJSAVREMENIJA TEHNOLOGIJA U NASTAVI",
      subtitle: "Tehnologija koja služi detetu — ne obrnuto",
      text: "Ono što Savremenu zaista izdvaja je to kako učenici umesto pasivni konzumenti tehnologije postaju kreativni kreatori igrica i robota. Svaka tehnologija ima jasnu svrhu, priprema učenike za buducnost i proces učenje podiže na viši nivo.",
    },
    {
      title: "POSVEĆENI NASTAVNICI",
      subtitle: "Podrška i podsticaj za svako dete",
      text: "Stručnost, empatija, kreativnost i strast prema radu sa decom nisu opcija, već standard za učitelje i nastavnike Savreme. I to je siguran recept da se svaki učenik osećaj vidjeno, voljeno, podržano i da svako dete ostvari i prestigne svoj potencijal.",
    },
    {
      title: "LIFE SKILLS PROGRAM ŽIVOTNIH VEŠTINA",
      subtitle: "Priprema dete za stvarni svet",
      text: "Pored zvaničnog programa, svako dete uči i ono što mu je zaista potrebno kroz život — kako da upravlja novcem, kako da reši konflikt, kako da kuva, šije, čuva prirodu, razume emocije i snađe se u stvarnom svetu. Zato je Savremena škola koja zaista priprema decu za život.",
    },
  ];
  
  export default benefitsData;